import { UserURL } from "./UserURL";
import UsersPageWrapper from "../../components/page_wrappers/UsersPageWrapper";
import ProtectedRoutes from "../ProtectedRoutes";

import UserDashboard from "../../pages/user_pages/UserDashboard";
import UserBusinessHub from "../../pages/user_pages/UserBusinessHub";
import UserInvoiceDashboard from "../../pages/user_pages/UserInvoiceDashboard";
import CreateManualEntry from "../../pages/user_pages/CreateManualEntry";
import InvoiceEditPage from "../../pages/user_pages/InvoiceEditPage";

const routeConfigs = [
    { path: UserURL.USER_DASHBOARD, component: UserDashboard, protected: true },
    { path: UserURL.USER_BUSINESS_HUB, component: UserBusinessHub, protected: true },
    { path: UserURL.USER_INVOICE_DASHBOARD, component: UserInvoiceDashboard, protected: true },
    { path: UserURL.USER_CREATE_MANUAL_ENTRY, component: CreateManualEntry, protected: true },
    { path: UserURL.USER_INVOICE_EDIT, component: InvoiceEditPage, protected: true },
];

const UserRoutes = routeConfigs.map(
    route => ({
        path: route.path,
        element: route.protected
        ? (
            <ProtectedRoutes>
                <UsersPageWrapper>
                    <route.component />
                </UsersPageWrapper>
            </ProtectedRoutes>
        ) : (
            <route.component />
        )
    })
);

export default UserRoutes;
